module.exports = __webpack_public_path__ + "img/title2.a60e3a36.png";